import graphql__dccf99ecbd22750904ac from "./__generated__/useAnswerShouldBeConditionnallyHidden_answer.graphql.js";import { useEffect, useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";

import { useForm } from "../Form/withFormStore";
import getFormFieldValue from "../../helpers/getFormFieldValue";

import { removeField } from "../../reducers/form";

export const shouldAnswerBeDisplayed = (answer, formState) => {
  const { displayConditionAnswers, formField } = answer;
  const { displayConditions } = formField;

  if (!displayConditions.length) return true;

  return displayConditions.some(displayCondition => {
    const { formFieldName: conditionFieldName, conditionOptions } = displayCondition;

    const matchesAnyConditionOption = fieldValue =>
      conditionOptions.some(conditionOption => {
        const values = Array.isArray(fieldValue) ? fieldValue : fieldValue.values;
        const other = fieldValue.other;

        return (
          values?.includes(conditionOption.option?.id) ||
          (conditionOption.otherOption && other)
        );
      });

    const fieldValue = getFormFieldValue(formState, conditionFieldName);

    if (fieldValue) {
      // If the value is found in the current form page store, use it to check if the
      // condition is met
      return matchesAnyConditionOption(fieldValue);
    } else {
      // If the value is not found, it may come from another page's answer, so we
      // check the associated display conditions from the AnswerBase
      // displayConditionAnswers GraphQL field.
      return displayConditionAnswers.some(answer => {
        const {
          values,
          formField: { fieldName }
        } = answer;
        if (fieldName !== conditionFieldName || !values) return false;

        return matchesAnyConditionOption({ values, other: answer.other });
      });
    }
  });
};

export const useAnswerShouldBeConditionnallyHidden = props => {
  const answer = useFragment(useAnswerShouldBeConditionnallyHidden_answer, props.answer);
  const { fieldName } = answer.formField;

  const { formKey, formState } = useForm();

  // Check whether the associated form field has not display conditions, which means that
  // it should always be display, or whether there are display conditions that are met.
  const shouldBeDisplayed = useMemo(
    () => shouldAnswerBeDisplayed(answer, formState),
    [answer, formState]
  );

  const dispatch = useDispatch();

  // This allows removing the field from the schema when it's not displayed, avoiding
  // validation errors and sending hidden data.
  useEffect(() => {
    // Don't try to remove fields that should be displayed, neither those that should
    // be hidden but are not stored in the form state, like the presentation fields.
    if (shouldBeDisplayed || !formState.fields[fieldName]) return;

    dispatch(removeField(formKey, fieldName));
  }, [dispatch, fieldName, formKey, formState.fields, shouldBeDisplayed]);

  return !shouldBeDisplayed;
};

const useAnswerShouldBeConditionnallyHidden_answer = graphql__dccf99ecbd22750904ac;
